import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SupportedLangsEnum } from './shared/enums/supportedLangs.enum';

import Backend from 'i18next-http-backend';

import countries from 'i18n-iso-countries';
import LanguageDetector from 'i18next-browser-languagedetector';

import pl from 'i18n-iso-countries/langs/pl.json';
import uk from 'i18n-iso-countries/langs/uk.json';
import es from 'i18n-iso-countries/langs/es.json';
import en from 'i18n-iso-countries/langs/en.json';

import translationsManifest from './translations-manifest.json';

countries.registerLocale(pl);
countries.registerLocale(uk);
countries.registerLocale(es);
countries.registerLocale(en);

export const defaultNS = 'app';

const manifest: Record<string, string> = translationsManifest;

const getHashedPath = (lng: string, ns: string) => {
  const originalPath: string = `${lng}/${ns}.json`;
  return manifest?.[originalPath] || `${lng}/${ns}.json`;
};

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    load: 'languageOnly',
    debug: import.meta.env.DEV,
    fallbackLng: SupportedLangsEnum.en,
    supportedLngs: Object.values(SupportedLangsEnum),
    interpolation: {
      escapeValue: false,
    },
    // TODO need to migrate to v4
    compatibilityJSON: 'v3',
    defaultNS,
    ns: [defaultNS, 'ui'],
    backend: {
      loadPath: (lng: string, ns: string) => `/locales/${getHashedPath(lng, ns)}`,
      maxRetries: 3,
      retryDelay: 1000,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'mindlyLocale',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => lng.split('-')[0],
    },
  });

export default i18n;
